<template>
  <div>
    <div class="collection-bubble">
      <figure class="image is-square collection-image">
        <img
          v-if="resumeImage"
          class="is-rounded collection-image"
          :src="resumeImage.fileUrl"
        />
      </figure>
    </div>
    <p class="has-text-weight-bold is-5">{{ collection.title }}</p>
  </div>
</template>

<script>
export default {
  props: {
    collection: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    resumeImage () {
      if (this.collection['resume-image']) {
        return this.collection['resume-image'][0]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/msteam-style";

@media screen and (min-width: 320px) {
  .collection-bubble {
    padding: 0rem;
  }
}

@media screen and (min-width: 769px) {
  .collection-bubble {
    padding: 1rem;
  }
}
.collection-image > img {
  padding: 0.75rem;
  border: solid 3px $primary;
  object-fit: cover;
}

.title {
  margin-top: 1rem !important;
}

@media screen and (min-width: 1024px) {
 .hero-banner {
  clip-path: ellipse(70% 70% at 50% 30%);
}
}
</style>
